import { create } from 'zustand'
import { IssueT } from '@/routes/projectStages/issues/lib/types/issuesTypes.ts'
import { IssuesByStatusAndPriorityT } from '@/routes/projectStages/issues/lib/hooks/useInitialIssuesSort.ts'

type TablePaginationT = {
  pageIndex: number
  pageSize: number
}

type IssuesStoreT = {
  issuesCreatedByMe: IssueT[]
  setIssuesCreatedByMe: (issues: IssueT[]) => void
  issuesAssignedToMe: IssueT[]
  setIssuesAssignedToMe: (issues: IssueT[]) => void
  draftIssues: IssueT[]
  setDraftIssues: (issues: IssueT[]) => void
  addDraftIssue: (issue: IssueT) => void
  deleteDraftIssue: (id: string) => void
  issuesByStatus: IssuesByStatusAndPriorityT
  setIssuesByStatus: (issuesByStatus: IssuesByStatusAndPriorityT) => void
  allSortedIssuesFlatten: IssueT[]
  setAllSortedIssuesFlatten: (issues: IssueT[]) => void
  allIssuesRaw: IssueT[]
  setAllIssuesRaw: (issues: IssueT[]) => void
  issuesByStatusAndPriority: IssuesByStatusAndPriorityT
  setIssuesByStatusAndPriority: (issuesByStatusAndPriority: IssuesByStatusAndPriorityT) => void
  resetIssuesStore: () => void
  allIssuesFiltered: IssueT[]
  setAllIssuesFiltered: (issues: IssueT[]) => void
  draftIssuesFiltered: IssueT[]
  setDraftIssuesFiltered: (issues: IssueT[]) => void
  issuesCreatedByMeFiltered: IssueT[]
  setIssuesCreatedByMeFiltered: (issues: IssueT[]) => void
  issuesAssignedToMeFiltered: IssueT[]
  setIssuesAssignedToMeFiltered: (issues: IssueT[]) => void
  lastOpenedIssue: { id: string; statusIri: string; pageIndex: number }
  setLastOpenedIssue: (issueId: string, statusId: string, pageIndex?: number) => void
  issuesRowsPagination: TablePaginationT
  setIssuesRowsPagination: (
    updater: TablePaginationT | ((state: TablePaginationT) => TablePaginationT),
  ) => void
}
export const useIssuesStore = create<IssuesStoreT>(set => ({
  issuesCreatedByMe: [],
  issuesAssignedToMe: [],
  draftIssues: [],
  issuesByStatus: [],
  allIssuesRaw: [],
  allSortedIssuesFlatten: [],
  issuesByStatusAndPriority: [],
  allIssuesFiltered: [],
  setAllIssuesFiltered: allIssuesFiltered => set({ allIssuesFiltered }),
  setIssuesCreatedByMe: issuesCreatedByMe => set({ issuesCreatedByMe }),
  setIssuesAssignedToMe: issuesAssignedToMe => set({ issuesAssignedToMe }),
  addDraftIssue: issue =>
    set(state => {
      return { draftIssues: [...state.draftIssues, issue] }
    }),
  deleteDraftIssue: id =>
    set(state => {
      // console.log(`deleting draft`, id)
      // console.log(`before:`, state.draftIssues)
      const filtered = state.draftIssues.filter(i => i.id !== Number(id))

      // console.log(`after delete: `, filtered)

      return { draftIssues: filtered }
    }),
  setDraftIssues: draftIssues => set({ draftIssues }),
  setIssuesByStatus: issuesByStatus => set({ issuesByStatus }),
  setAllSortedIssuesFlatten: allSortedIssuesFlatten => set({ allSortedIssuesFlatten }),
  setAllIssuesRaw: allIssuesRaw => set({ allIssuesRaw }),
  setIssuesByStatusAndPriority: issuesByStatusAndPriority => set({ issuesByStatusAndPriority }),
  setDraftIssuesFiltered: draftIssuesFiltered => set({ draftIssuesFiltered }),
  setIssuesCreatedByMeFiltered: issuesCreatedByMeFiltered => set({ issuesCreatedByMeFiltered }),
  setIssuesAssignedToMeFiltered: issuesAssignedToMeFiltered => set({ issuesAssignedToMeFiltered }),
  setLastOpenedIssue: (lastOpenedIssue, statusIri, pageIndex) =>
    set({
      lastOpenedIssue: { id: lastOpenedIssue, statusIri: statusIri, pageIndex: pageIndex ?? 0 },
    }),
  issuesAssignedToMeFiltered: [],
  draftIssuesFiltered: [],
  issuesCreatedByMeFiltered: [],
  lastOpenedIssue: {
    id: '',
    statusIri: '',
    pageIndex: 0,
  },
  issuesRowsPagination: {
    pageIndex: 0,
    pageSize: 50,
  },
  setIssuesRowsPagination: updater =>
    // this is to keep page index during subscriber updates within tenstack table
    set(state => {
      if (typeof updater === 'function') {
        return { issuesRowsPagination: updater(state.issuesRowsPagination) }
      }
      return { issuesRowsPagination: updater }
    }),

  resetIssuesStore: () =>
    set({
      issuesByStatus: [],
      allSortedIssuesFlatten: [],
      allIssuesRaw: [],
      draftIssues: [],
      issuesByStatusAndPriority: [],
      issuesCreatedByMe: [],
      issuesAssignedToMe: [],
    }),
}))
